import type { FaireProductEntity } from "../../entity_types/product";

export const p_wgjmt3u3hj: FaireProductEntity = {
  token: "p_wgjmt3u3hj",
  type: "product",
  name: "Deep Toilet Thoughts: A Life-Affirming Alternative to Doomscrolling!",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/ae1c0196ca44ccfb15b953a5bda8cae1dac3d4b536696bf5df8bd46cf2d81653.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9aa9dce2f6484f809d7a1eff3cd77b9963d5f1448eade79051fc2b882e4c4bb1.jpeg"
  ],
  priceDollars: 8,
  description: "This appealing bathroom companion is filled with games, puzzles and quizzes, plus profound-yet-silly affirmations and “deep thoughts” to keep you entertained on the throne—all housed in an eye-catching (and water-resistant!) cover. Make every visit to the loo a more life-affirming experience! A totally original housewarming gift for fans of home décor with a sense of humor! Also makes a unique hostess gift, gag gift, white elephant or secret Santa gift! We hardly need mention: this makes a perfect funny gift for Dad! Water-resistant hardcover with foil stamping & debossing; 88 pages, 8.5 x 5.5 inches.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:50.810Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
